import React, { Component } from 'react';
import { Breadcrumb, Select, Button, message, Divider, DatePicker } from 'antd';
import moment from 'moment';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import CptGrid from './CptGrid';
import AddOrEditCptModalDialog from './AddOrEditCptModalDialog';
import DelCptModalDialog from './DelCptModalDialog';
import CptNoteModalDialog from './CptNoteModalDialog';
import OperationRecordDialog from '../../common/operationRcd/components/OperationRecordDialog';
import './CptDashboard.css';

const Option = Select.Option;

class CptDashboard extends Component {
  state = {
    yearPickerMode: 'year',
    pendingSelectId: null,
  };

  componentDidMount() {
    let employee = null;
    let year = null;
    let id = null;
    const searchStr = this.props.location ? this.props.location.search : null;
    if (searchStr && searchStr.indexOf('?') >= 0) {
      const searchArray = searchStr.substring(searchStr.indexOf('?') + 1).split('&');
      for (let i = 0; i < searchArray.length; i++) {
        const subParamArray = searchArray[i].split('=');
        if (subParamArray && subParamArray.length > 1) {
          if (subParamArray[0] === 'employee') {
            employee = subParamArray[1].replace(/%20/g, ' ');
          } else if (subParamArray[0] === 'year') {
            year = subParamArray[1];
          } else if (subParamArray[0] === 'id') {
            id = subParamArray[1];
          }
        }
      }
    }

    this.props.loadCptEmployeeOptions('');
    if (employee) {
      this.onInputChange({ name: 'employee', value: employee });
    }
    if (year) {
      this.onInputChange({ name: 'year', value: year });
    }
    if (id) {
      this.setState({ pendingSelectId: id });
    }
    const { employee: currentEmployee, year: currentYear } = this.props.cptQueryFields;
    this.props.loadCptInfo({
      employee: employee || currentEmployee,
      year: year || currentYear,
    });
  }

  componentDidUpdate() {
    const {
      loadCptInfoActionStatus,
      loadCptInfoResp,
      loadCptEmployeeOptionsActionStatus,
      submitCptApprovalActionStatus,
      submitCptApprovalRespErrMsg,
    } = this.props;

    if (loadCptInfoActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadCptInfoActionStatus();
      if (this.state.pendingSelectId && this.cptGridRef) {
        this.cptGridRef.selectRowById(this.state.pendingSelectId);
        this.setState({ pendingSelectId: null });
      }
    }
    if (loadCptInfoActionStatus === ACTION_STATUS.ERROR) {
      let err = 'Load CPT records failed';
      if (loadCptInfoResp && loadCptInfoResp.respMessage) {
        err = loadCptInfoResp.respMessage;
      }
      message.error(err);
      this.props.initLoadCptInfoActionStatus();
    }

    if (loadCptEmployeeOptionsActionStatus === ACTION_STATUS.SUCCESS ||
      loadCptEmployeeOptionsActionStatus === ACTION_STATUS.ERROR) {
      this.props.initLoadCptEmployeeOptionsActionStatus();
    }

    if (submitCptApprovalActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Update CPT approval status succeeded');
      this.props.initSubmitCptApprovalActionStatus();
      this.refreshBtnOnClicked();
    }
    if (submitCptApprovalActionStatus === ACTION_STATUS.ERROR) {
      message.error(submitCptApprovalRespErrMsg || 'Update CPT approval status failed');
      this.props.initSubmitCptApprovalActionStatus();
    }

  }

  onInputChange = ({ name, value }) => {
    this.props.onCptQueryInputChange({ name, value });
  };

  onYearChange = (date, dateString) => {
    this.onInputChange({ name: 'year', value: date ? dateString : '' });
  };

  onYearPanelChange = value => {
    this.setState({ yearPickerMode: 'year' });
    this.onInputChange({ name: 'year', value: value ? value.format('YYYY') : '' });
  };

  onYearOpenChange = open => {
    if (!open) {
      this.setState({ yearPickerMode: 'year' });
    }
  };

  refreshBtnOnClicked = () => {
    const { employee, year } = this.props.cptQueryFields;
    this.props.loadCptInfo({ employee, year });
  };

  getSingleSelectedRecord = () => {
    const { selectedCptInfoArray } = this.props;
    if (selectedCptInfoArray.length !== 1) {
      message.warning('Please choose one and only one CPT record');
      return null;
    }
    return selectedCptInfoArray[0];
  };

  addOrEditBtnOnClicked = mode => {
    if (mode === 'ADD') {
      this.props.openAddOrEditCptModal(mode, null);
      return;
    }
    const currentRecord = this.getSingleSelectedRecord();
    if (!currentRecord) {
      return;
    }
    this.props.openAddOrEditCptModal(mode, currentRecord);
  };

  approvalBtnOnClicked = actionType => {
    const currentRecord = this.getSingleSelectedRecord();
    if (!currentRecord) {
      return;
    }
    this.props.submitCptApproval({ id: currentRecord.id }, actionType);
  };

  delBtnOnClicked = () => {
    const currentRecord = this.getSingleSelectedRecord();
    if (!currentRecord) {
      return;
    }
    this.props.openDelCptModal(currentRecord);
  };

  operationRcdBtnOnClicked = () => {
    const { selectedCptInfoArray } = this.props;
    const queryFields = { module: 'CPT' };
    if (selectedCptInfoArray && selectedCptInfoArray.length > 0) {
      queryFields.dataId = selectedCptInfoArray.map(item => item.id).join(',');
    }
    this.props.doOperationRecordAction({
      action: 'OPEN_AND_QUERY',
      queryFields,
      customColumns: ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'],
    });
  };

  render() {
    const { employeeOptions, cptQueryFields, loadCptInfoActionStatus, loadCptNoteActionStatus } = this.props;
    const { employee, year } = cptQueryFields;
    const refreshBtnIsLoading = loadCptInfoActionStatus === ACTION_STATUS.LOGINING;
    const noteBtnIsLoading = loadCptNoteActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div className="CptWrapper">
        <div className="breadcrumbWrapper">
          <Breadcrumb>
            <Breadcrumb.Item>Monitoring</Breadcrumb.Item>
            <Breadcrumb.Item>CPT</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="CptOperationBar">
          <Select
            allowClear
            size="small"
            showSearch
            filterOption={false}
            value={!employee ? undefined : employee}
            style={{ width: 180, marginLeft: 10 }}
            placeholder="Employee"
            onSearch={this.props.loadCptEmployeeOptions}
            onFocus={() => this.props.loadCptEmployeeOptions('')}
            onChange={value => this.onInputChange({ name: 'employee', value })}
          >
            {employeeOptions.map(item => (
              <Option key={item} value={item}>{item}</Option>
            ))}
          </Select>
          <DatePicker
            allowClear
            size="small"
            mode={this.state.yearPickerMode}
            value={year ? moment(year, 'YYYY') : null}
            format="YYYY"
            style={{ width: 120, marginLeft: 10 }}
            placeholder="Year"
            onChange={this.onYearChange}
            onPanelChange={this.onYearPanelChange}
            onOpenChange={this.onYearOpenChange}
          />
          <Button
            onClick={this.refreshBtnOnClicked}
            loading={refreshBtnIsLoading}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
            icon="search"
          />

          <Divider type="vertical" />

          <Button
            onClick={() => this.addOrEditBtnOnClicked('ADD')}
            size="small"
            className="positive-button"
          >
            Add
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked('COPY')}
            size="small"
            style={{ marginLeft: 10 }}
            className="positive-button"
          >
            Copy
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked('EDIT')}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Edit
          </Button>
          <Button
            onClick={this.delBtnOnClicked}
            size="small"
            style={{ marginLeft: 10 }}
            className="negative-button"
          >
            Del
          </Button>
          <Button
            onClick={() => this.approvalBtnOnClicked('APPROVE')}
            size="small"
            style={{ marginLeft: 10 }}
            className="positive-button"
          >
            Approve
          </Button>
          <Button
            onClick={() => this.approvalBtnOnClicked('REJECT')}
            size="small"
            style={{ marginLeft: 10 }}
            className="negative-button"
          >
            Reject
          </Button>
          <Button
            onClick={this.props.loadCptNote}
            loading={noteBtnIsLoading}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Note
          </Button>
          <Divider type="vertical" />

          <Button
            onClick={this.operationRcdBtnOnClicked}
            size="small"
            type="primary"
          >
            Operation Record
          </Button>
        </div>

        <div className="CptGrid">
          <CptGrid
            {...this.props}
            ref={ref => { this.cptGridRef = ref; }}
          />
        </div>
        <AddOrEditCptModalDialog {...this.props} />
        <DelCptModalDialog {...this.props} />
        <CptNoteModalDialog {...this.props} />
        <OperationRecordDialog {...this.props} />
      </div>
    );
  }
}

export default CptDashboard;
